export default (state) => {
  const feed = { ...state.feed };
  //We need to set "already_synced" flag in case if user is logged in
  //state.auth is not available during upgrade, because it's located in separate reducer. So have to use "profile"
  feed.pain_guide_already_synced = !!state.profile?.record_id;
  return { ...state, feed };
};
